import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import errorImg from "./images/computer.webp";

import './styles/ErrorPage.css';

const ErrorPage = () => {
    const { t } = useTranslation();
    return (
        <div className="error_page">
            <div className='error_page_error'>{t('errorpage.error')}</div>

            <img className='error_page_img' src={errorImg} alt={t('errorpage.errorImage')} />

            <div className='error_page_not_found'>{t('errorpage.pageNotFound')}</div>

            <div className='error_page_text'>{t('errorpage.pageDoesNotExist')}</div>

            <Link to="/">{t('errorpage.goToHomepage')}</Link>
        </div>
    );
};

export default ErrorPage;
